import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";
import { SwrConfigOptions } from "utils/helpers/Common";
/**
 * A custom hook to fetch and manage settings data using SWR
 * @returns {Object} The settings data and SWR utilities
 * @returns {Object} returns.data - The settings data
 * @returns {boolean} returns.isLoading - Loading state
 * @returns {Object} returns.error - Error object if any
 * @returns {Function} returns.mutate - Function to manually revalidate data
 */
const useGetSettings = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const { data: settings, error, isLoading, mutate } = useSWR(user ? { url: "/settings", dispatch } : null, SwrConfigOptions);
	return {
		settings: settings?.data,
		isLoading,
		error,
		mutate,
	};
};

export default useGetSettings;
